import { render, staticRenderFns } from "./productEdit.vue?vue&type=template&id=325e353a&scoped=true"
import script from "./productEdit.vue?vue&type=script&lang=js"
export * from "./productEdit.vue?vue&type=script&lang=js"
import style0 from "./productEdit.vue?vue&type=style&index=0&id=325e353a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e353a",
  null
  
)

export default component.exports